import React from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import useLocale from 'components/useLocale';
import { JSSClasses } from 'proptypes/jss-prop-types';
import classnames from 'classnames';

const MEMO = 'Memo';

const getCellVal = (arr, key) => {
  const col = find(arr, (obj) => {
    return obj.head === key;
  });
  return col?.value;
};

const DuplicateAlert = ({
  classes: { alertCol, alertDetails, alertHead, alertMemoCol, alertValue, section },
  duplicateDetails,
  duplicateMsg
}) => {
  const locale = useLocale();
  return (
    <div>
      {duplicateDetails ? (
        <div className={section}>
          <div className={alertCol} style={{ maxWidth: '100%' }}>
            <p>{duplicateMsg}</p>
          </div>
          {Array.isArray(duplicateDetails[0]) ? (
            <>
              {duplicateDetails.map((detail, index) => {
                if (index > 4) return null;
                const paymentName = getCellVal(detail, 'paymentName');
                const custTraceNum = getCellVal(detail, 'custTraceNum');
                const initiatedBy = getCellVal(detail, 'initiatedBy');
                const initiatedDate = getCellVal(detail, 'initiatedDate');
                const approvedBy = getCellVal(detail, 'approvedBy');
                const approvedDate = getCellVal(detail, 'approvedDate');
                return (
                  <section key={`details-${paymentName}`} className={alertDetails}>
                    <div className={alertCol}>
                      <div className={alertHead}>{locale[`common.paymentName`]}</div>
                      <div className={alertValue}>{paymentName}</div>
                    </div>
                    <div className={alertCol} key={`details-${custTraceNum}`}>
                      <div className={alertHead}>{locale[`common.custTraceNum`]}</div>
                      <div className={alertValue}>{custTraceNum}</div>
                    </div>
                    <div className={alertCol} key={`details-${initiatedBy}`}>
                      <div className={alertHead}>{locale[`common.initiatedBy`]}</div>
                      <div className={alertValue}>{initiatedBy}</div>
                    </div>
                    <div className={alertCol} key={`details-${initiatedDate}`}>
                      <div className={alertHead}>{locale[`common.initiatedDate`]}</div>
                      <div className={alertValue}>{initiatedDate}</div>
                    </div>
                    <div className={alertCol} key={`details-${approvedBy}`}>
                      <div className={alertHead}>{locale[`common.approvedBy`]}</div>
                      <div className={alertValue}>{approvedBy}</div>
                    </div>
                    <div className={alertCol} key={`details-${approvedDate}`}>
                      <div className={alertHead}>{locale[`common.approvedDate`]}</div>
                      <div className={alertValue}>{approvedDate}</div>
                    </div>
                  </section>
                );
              })}
              {duplicateDetails.length > 5
                ? `${locale['common.and']} ${duplicateDetails.length - 5} ${
                    locale['common.otherPotentialDuplicates']
                  }.`
                : null}
            </>
          ) : (
            <>
              <section className={alertDetails}>
                {duplicateDetails.map((detail, index) => {
                  if (index > 4) return null;
                  return (
                    <div key={detail.head}>
                      <div
                        className={classnames(alertCol, { alertMemoCol: detail.head === MEMO })}
                        key={`details-${detail.head}`}
                      >
                        <div className={alertHead}>{locale[`common.${detail.head}`]}</div>
                        <div className={alertValue}>{detail.value}</div>
                      </div>
                    </div>
                  );
                })}
              </section>
              {duplicateDetails.length > 5 ? (
                <section className={alertDetails}>
                  {`${locale['common.and']} ${duplicateDetails.length - 5} ${
                    locale['common.otherPotentialDuplicates']
                  }.`}
                </section>
              ) : null}
            </>
          )}
        </div>
      ) : null}
    </div>
  );
};

DuplicateAlert.defaultProps = {
  classes: {}
};

DuplicateAlert.propTypes = {
  classes: JSSClasses,
  duplicateMsg: PropTypes.string.isRequired,
  duplicateDetails: PropTypes.shape([]).isRequired
};

export default DuplicateAlert;
